import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/navbar-icons/search.svg'


const _withScopeId = n => (_pushScopeId("data-v-6053195a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center w-full focus:bg-white" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mx-4"
}, null, -1))
const _hoisted_3 = ["name", "value", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-row py-4 w-full", 
        _ctx.style
          ? 'border-2 border-gray-300 rounded-md bg-white'
          : 'rounded-2xl bg-background'
      ]),
      style: _normalizeStyle(_ctx.style ? 'background-color: #FFF' : 'background-color: #f7f7fc')
    }, [
      _hoisted_2,
      _createElementVNode("input", {
        type: "text",
        name: _ctx.name,
        value: _ctx.modelValue,
        onKeyup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
        placeholder: _ctx.placeholder,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        style: _normalizeStyle(_ctx.style ? 'background-color: #fff' : 'background-color: #f7f7fc'),
        class: _normalizeClass([_ctx.style ? ' text-gray-500 font-medium' : '', "apperance-none border-0 rounded-2xl w-full bg-background px-4 focus:outline-none focus:ring-0 focus:ring-black focus:bg-white"])
      }, null, 46, _hoisted_3)
    ], 6)
  ]))
}